import api from "../../Utils/interceptors";

export const getAssetDetails = (id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_ASSET_DETAILS_REQUEST" });
    const { data } = await api.get(`/asset/${id}`);
    dispatch({ type: "GET_ASSET_DETAILS_SUCCESS", payload: data });
  } catch (error) {
    dispatch({
      type: "GET_ASSET_DETAILS_FAIL",
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const createAssetCategory = (categoryData) => async (dispatch) => {
  try {
    dispatch({ type: "CREATE_ASSET_CATEGORY_REQUEST" });
    const { data } = await api.post("/asset-category/create", categoryData);
    dispatch({
      type: "CREATE_ASSET_CATEGORY_SUCCESS",
      payload: data,
      success: true,
    });
  } catch (e) {
    dispatch({
      type: "CREATE_ASSET_CATEGORY_FAIL",
      payload: e.response?.data?.message || e.message,
      success: false,
    });
  }
};

export const createAsset = (assetData) => async (dispatch) => {
  try {
    dispatch({ type: "CREATE_ASSET_REQUEST" });
    const { data } = await api.post("/asset/create", assetData);
    dispatch({ type: "CREATE_ASSET_SUCCESS", payload: data, success: true });
  } catch (e) {
    dispatch({
      type: "CREATE_ASSET_FAIL",
      payload: e.response?.data?.message || e.message,
      success: false,
    });
  }
};

export const getAllAssets =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_ASSETS_REQUEST" });
      const { data } = await api.get("/assets/all", { params });
      dispatch({ type: "GET_ASSETS_SUCCESS", payload: data });
    } catch (error) {
      dispatch({
        type: "GET_ASSETS_FAIL",
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const getAllAssetCategories = () => async (dispatch) => {
  try {
    dispatch({ type: "GET_ASSET_CATEGORIES_REQUEST" });
    const { data } = await api.get("/asset-categories/all");
    dispatch({ type: "GET_ASSET_CATEGORIES_SUCCESS", payload: data });
  } catch (error) {
    dispatch({
      type: "GET_ASSET_CATEGORIES_FAIL",
      payload: error.response?.data?.message || error.message,
    });
  }
};
